import { createSelector } from 'reselect';

const getRootState = (state) => state.root;

export const getRootStateSelector = createSelector([getRootState], (rootState) => {
  const {
    tickets,
    fix_pagination,
    users,
    tasks,
    updates,
    orders,
    pagination,
    statuses,
    filters,
    search_types,
    staff,
    sort,
    fields,
    access,
    bulk_actions,
    types,
  } = rootState.data;
  const { config } = rootState;

  return {
    tasks,
    users,
    tickets: tickets ? tickets.map((ticket) => {
      if (rootState.data?.user_levels && ticket.user_level) {
        const levels = rootState.data?.user_levels;
        return {
          ...ticket,
          user_level: levels.find((level) => Number(level.id) === Number(ticket.user_level)),
        }
      }
      return ticket
    }) : [],
    orders,
    updates,
    statuses,
    filters,
    search_types,
    pagination,
    staff,
    discounts: rootState.data?.discounts || [],
    user_levels: rootState.data?.user_levels || [],
    columns: sort?.columns,
    fields,
    access,
    config,
    bulk_actions,
    fix_pagination,
    types,
  };
});
